// Helper function to check if values differ between branches
export function checkForDifferentValues(values: Array<unknown>): boolean {
  const validValues = values.filter(value => value !== undefined && value !== null);

  return validValues.length > 1 && new Set(validValues).size > 1;
}
